import { render, staticRenderFns } from "./ExtraFilters.vue?vue&type=template&id=37f772ba&scoped=true&"
import script from "./ExtraFilters.vue?vue&type=script&lang=js&"
export * from "./ExtraFilters.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFilters.vue?vue&type=style&index=0&id=37f772ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f772ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f772ba')) {
      api.createRecord('37f772ba', component.options)
    } else {
      api.reload('37f772ba', component.options)
    }
    module.hot.accept("./ExtraFilters.vue?vue&type=template&id=37f772ba&scoped=true&", function () {
      api.rerender('37f772ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/ExtraFilters.vue"
export default component.exports